/*
|-------------------------------------------------------------------------------
| Mixins for general methods applied accross multiple components/pages.
|-------------------------------------------------------------------------------
*/
import strapiServices from '../services/StrapiServices';
import * as helpers from "./helperUtils";

export default {
    data() {
        return {
            imageGallery: [],
            galleryFilters: [
                "All",  
                "Community",
                "Concept Art",
                "Gameplay",
            ],
            lightBoxSources: [],
            activeGalFilter: "All",
        };
    },
    mounted() {
        this.$watch(
        "$refs.lightbox.$data.isOpen",
            (newValue, old_value) => {
                if (newValue == false && this.toggleLightBox == true) {
                    this.toggleLightBox = false;
                    this.$refs.lightbox.$data.isOpen = false;
                    
                    let el = document.querySelector("html");
                    el.style.overflow = 'auto';
                    
                } else if (newValue == true && this.toggleLightBox == false) {
                    this.$refs.lightbox.$data.isOpen = false;
                    let el = document.querySelector("html");
                    el.style.overflow = 'auto';
                }
            }
        );
    },
    computed: {
        mainUrl() {
            let baseUrl = window.location.origin;
            let strapiUrl = "";
            if (baseUrl.includes("develop")) {
                strapiUrl = "https://devstrapi.hermertiawars.com"
            } else if (baseUrl.includes("hermertiawars.com") && !baseUrl.includes("develop")) {
                strapiUrl = "https://strapi.hermertiawars.com"
            } else {
                strapiUrl = helpers.getEnvironmentVar("VUE_APP_STRAPI_URL", "");
            }
    
            return strapiUrl;
        }
    },
    methods: {
        async getMediaImages() {
            try {
                let images = await strapiServices.GET_STRAPI("/upload/files/");
                let imageInfo = images.data;
    
                this.imageGallery = imageInfo.map(obj => {
                    if (obj.name.includes("gallery_")) {
                        let url = obj.url
                        let thumbUrl = obj.formats.thumbnail.url
                        if (this.mainUrl) {
                            url = this.mainUrl + url.replace(/^.*\/\/[^\/]+/, '');
                            thumbUrl = this.mainUrl + thumbUrl.replace(/^.*\/\/[^\/]+/, '');
                        }
    
                        return {"original": url, "thumbnail": thumbUrl, "name": obj.name}
                    }
                })
    
                this.imageGallery = this.imageGallery.filter(function( element ) {
                    return element !== undefined;
                });
    
                this.imageGallery.forEach((imgInfoObj) => {
                    this.lightBoxSources.push(imgInfoObj.original);
                });
            } catch (err) {
                console.log(err);
            }
        },
        openGallery(url) {
            this.lightBoxSources = this.lightBoxSources.concat(this.lightBoxSources.splice(0,this.lightBoxSources.indexOf(url)));
            this.toggleLightBox = true;
            let el = document.querySelector("html");
            el.style.overflow = 'hidden';
        },
        updateActiveGalFilter(value) {
            this.activeGalFilter = value;
            console.log(this.activeGalFilter);
        },
    }
};
